import useSWR from 'swr';

export const useReleaseNotes2 = () => {
    const { data, error, isValidating, isLoading, mutate } = useSWR(
        '/api/v1/releasenotes/list',
        fetcher,
        swrConfig);

    const items = data || [];

    return { items, error, isValidating, isLoading, mutate };
};

export const useDocumentTitle = (partNumber) => {
    const { data, error, isValidating, isLoading, mutate } = useSWR(
        `/api/v1/releasenotes/document/${partNumber}/title`,
        fetcher,
        swrConfig);

    const { title } = data || {};

    return { title, error, isValidating, isLoading, mutate };
};

export const useReleaseNotes = () => {
    const { data, error, isValidating, isLoading, mutate } = useSWR(
        getPath(),
        fetcher,
        swrConfig);

    return { data, error, isValidating, isLoading, mutate };
};

const getPath = () => {
    return `/api/v1/file/notes/list`;
}

const fetcher = (url) => {
    return fetch(url).then(response => response.json())
}

const swrConfig = {
    revalidateOnFocus: false,
    onErrorRetry: (error, key, config, revalidate, { retryCount }) => {
        // Never retry on 4XX error.
        if (error.status >= 400 && error.status < 500) return;

        //   // Never retry for a specific key.
        //   if (key === '/api/user') return

        // Only retry up to 1 times.
        if (retryCount > 1) return;

        // Retry after 1 seconds.
        setTimeout(() => { revalidate({ retryCount }); }, 1000)
    }
};